// Utility helpers for vocabulary topic metadata and URL-safe ids
const slugifyTopicId = (file, grade) => {
  const withoutExt = file.replace(/\.csv$/i, "");
  const withoutPrefix = withoutExt.replace(
    new RegExp(`^words-${grade}-`, "i"),
    "",
  );
  return withoutPrefix
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[^a-z0-9]+/gi, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
};

const withId = (grade, topic) => ({
  ...topic,
  id: topic.id || slugifyTopicId(topic.file, grade),
});

export const getTopicsForGrade = (grade) => {
  if (!grade) return [];

  const topicsByGrade = {
    grade10: [
      {
        file: `words-${grade}-HappyNewYearFromTheUAE.csv`,
        name: "שנה טובה מהאמירויות",
        icon: "🧕🏼",
        description: "אוצר מילים לפתיחת שנה",
      },
      {
        file: `words-${grade}-TheMermaid.csv`,
        name: "בת הים",
        icon: "🧜‍♀️",
        description: "אוצר מילים מתוך הסיפור בת הים",
      },
      {
        file: `words-${grade}-verbsFaala.csv`,
        name: "פעלים",
        icon: "فَعَلَ",
        description: "רשימת פעלים בעבר מבניין 1",
        iconColor: "bisque",
      },
      {
        file: `words-${grade}-MilotYachasAndMilotChibur.csv`,
        name: "מילות יחס ומילות חיבור",
        icon: "⛓️",
        description: "אוצר מילים של מילות יחס ומילות חיבור",
      },
      {
        file: `words-${grade}-runningGroup.csv`,
        name: "קבוצת ריצה",
        icon: "🏃",
        description: "אוצר מילים מתוך הסיפור רצים ללא גבולות",
      },
      {
        file: `words-${grade}-theFemaleSinger.csv`,
        name: "הזמרת",
        icon: "🎤",
        description: "אוצר מילים מתוך יחידת הלימוד על תמר שאוקי",
      },
    ],
    grade11: [
      {
        file: `words-${grade}-grandOpeningOfTheYear.csv`,
        name: "פתיחת השנה",
        icon: "🎉",
        description: "מילים - חופשת הקיץ",
        hidden: true,
      },
      {
        file: `words-${grade}-TheSchoolYear.csv`,
        name: "שנת הלימודים",
        icon: "🏫",
        description: "מילים מיחידת הלימוד בנושא שנת הלימודים",
      },
      {
        file: `words-${grade}-recycle.csv`,
        name: "מחזור",
        icon: "♻️",
        description: "מילים מיחידת הלימוד בנושא מחזור",
      },
      {
        file: `words-${grade}-PlainsCollection.csv`,
        name: "אוסף מטוסים",
        icon: "✈️",
        description: "מילים מיחידת הלימוד בנושא אוסף מטוסים",
      },
      {
        file: `words-${grade}-MoreAndMost.csv`,
        name: "יותר והכי",
        icon: "📈",
        description: "מילים מיחידת הלימוד בנושא ערך היתרון וההפלגה",
      },
      {
        file: `words-${grade}-CrossFit.csv`,
        name: "קרוספיט",
        icon: "🏋️‍♂️",
        description: "מילים מיחידת הלימוד בנושא קרוספיט",
      },
      {
        file: `words-${grade}-ArabMusic.csv`,
        name: "מוזיקה ערבית",
        icon: "🎵",
        description: "מילים מיחידת הלימוד בנושא מוזיקה ערבית",
      },
      {
        file: `words-${grade}-ThePoetNizarKabbani.csv`,
        name: "המשורר נזאר קבאני",
        icon: "✍🏼",
        description: "מילים מיחידת הלימוד בנושא המשורר נזאר קבאני",
      },
      {
        file: `words-${grade}-verbsFaala2.csv`,
        name: "בניין 2",
        icon: "فَعَّلَ",
        description: "אוצר מילים של בניין 2",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-verbsFaala3.csv`,
        name: "בניין 3",
        icon: "فَاعَلَ",
        description: "אוצר מילים של בניין 3",
        iconColor: "gold",
      },
      {
        file: `words-${grade}-verbsAfala4andTafaala5.csv`,
        name: "בניינים 4 ו-5",
        icon: "أَفْعَلَ تَفَعَّلَ",
        description: "אוצר מילים של בניינים 4 ו-5",
        iconColor: "brown",
      },
      {
        file: `words-${grade}-verbsTafaala6andinfaala7.csv`,
        name: "בניינים 6 ו-7",
        icon: "تَفَاعَلَ إِنْفَعَلَ",
        description: "אוצר מילים של בניינים 6 ו-7",
        iconColor: "darkblue",
      },
      {
        file: `words-${grade}-verbsIftaala8.csv`,
        name: "בניין 8",
        icon: "إِفْتَعَلَ",
        description: "אוצר מילים של בניין 8",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-verbsIstafala10.csv`,
        name: "בניין 10",
        icon: "إِسْتَفْعَلَ",
        description: "אוצר מילים של בניין 10",
        iconColor: "gold",
      },
    ],
    grade7: [
      {
        file: `words-${grade}-DavidErezAndBa.csv`,
        name: "האותיות דוד ארז ובא (أ, د, ذ, ر, ز, و, ب)",
        icon: "🌲",
        description: "תרגול אוצר מילים",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-YaNunTaTha.csv`,
        name: "אותיות בנתי + ת׳א (ب, ن, ت, ث, ي) ",
        icon: "👧🏼",
        description: "תרגול אוצר מילים",
        iconColor: "gold",
      },
      {
        file: `words-${grade}-theLetterHaa.csv`,
        name: "האות האא׳ (هـ)",
        icon: "هـ",
        description: "תרגול אוצר מילים",
        iconColor: "brown",
      },
      {
        file: `words-${grade}-theLetterLam.csv`,
        name: "האות לאם (ل)",
        icon: "ل",
        description: "תרגול אוצר מילים",
        iconColor: "darkblue",
      },
      {
        file: `words-${grade}-theLetterKaf.csv`,
        name: "האות כאף (ك)",
        icon: "ك",
        description: "תרגול אוצר מילים",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-theLetterMim.csv`,
        name: "האות מִים (م)",
        icon: "م",
        description: "תרגול אוצר מילים",
        iconColor: "gold",
      },
      {
        file: `words-${grade}-FaAndQaf.csv`,
        name: "האותיות פא (ف) וקאף (ق)",
        icon: "ف ق",
        description: "תרגול אוצר מילים",
        iconColor: "brown",
      },
      {
        file: `words-${grade}-theLetterAyn.csv`,
        name: "האות עַיְן (ع)",
        icon: "ع",
        description: "תרגול אוצר מילים",
        iconColor: "darkblue",
      },
      {
        file: `words-${grade}-theLetterRayn.csv`,
        name: "האות ע׳ין (غ)",
        icon: "غ",
        description: "תרגול אוצר מילים",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-theLetterSin.csv`,
        name: "האות סִין (س)",
        icon: "س",
        description: "תרגול אוצר מילים",
        iconColor: "gold",
      },
      {
        file: `words-${grade}-theLetterShin.csv`,
        name: "האות שִׁין (ش)",
        icon: "ش",
        description: "תרגול אוצר מילים",
        iconColor: "brown",
      },
      {
        file: `words-${grade}-theLetterTsad.csv`,
        name: "האות צאד (ص)",
        icon: "ص",
        description: "תרגול אוצר מילים",
        iconColor: "darkblue",
      },
      {
        file: `words-${grade}-theLetterDad.csv`,
        name: "האות צ׳אד (ض)",
        icon: "ض",
        description: "תרגול אוצר מילים",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-theLetterTaa.csv`,
        name: "האות טאא׳ (ط)",
        icon: "ط",
        description: "תרגול אוצר מילים",
        iconColor: "gold",
      },
      {
        file: `words-${grade}-theLetterThaa.csv`,
        name: "האות ט'אא׳ (ظ)",
        icon: "ظ",
        description: "תרגול אוצר מילים",
        iconColor: "brown",
      },
      {
        file: `words-${grade}-theLetterCha.csv`,
        name: "האות חאא' (ح)",
        icon: "ح",
        description: "תרגול אוצר מילים",
        iconColor: "darkblue",
      },
      {
        file: `words-${grade}-theLetterKha.csv`,
        name: "האות ח'אא' (خ)",
        icon: "خ",
        description: "תרגול אוצר מילים",
        iconColor: "antiquewhite",
      },
      {
        file: `words-${grade}-theLetterJim.csv`,
        name: "האות ג'ים (ج)",
        icon: "ج",
        description: "תרגול אוצר מילים",
        iconColor: "gold",
      },
    ],
  };

  const defaultTopics = [
    {
      file: `words-${grade}-HappyNewYearFromTheUAE.csv`,
      name: "שנה טובה מהאמירויות",
      icon: "🎉",
      description: "אוצר מילים לפתיחת שנה",
    },
  ];

  const topics = topicsByGrade[grade] || defaultTopics;
  return topics.map((topic) => withId(grade, topic));
};

export const findTopicById = (grade, topicId) => {
  if (!grade || !topicId) return undefined;
  return getTopicsForGrade(grade).find((topic) => topic.id === topicId);
};
